module.exports = __webpack_public_path__ + "assets/img/高灵活度的接入方案.253eeb23.jpg";